import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ApartmentService, BlockService } from '../../../../services';
import { ServiceBookService } from '../../../../services/serviceBook.service';
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_INIT_PATCH, SERVICEBOOK_SET_PATCH } from '../../../../store/service-book';
import { IPatchServiceBook } from '../../../../store/service-book/service-book-state.store';


const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)

@Component({
  name:'ServiceBookModal',
  components: {
  }
})
class ServiceBookModal extends Vue {

  @Prop({ type: [Number] })
  serviceBookId: number;


  @ServiceBookStore.Mutation(SERVICEBOOK_SET_PATCH)
  storeSetServiceBookPatchData: (patch: IPatchServiceBook) => void;

  @ServiceBookStore.Mutation(SERVICEBOOK_INIT_PATCH)
  storeInitServiceBookPatchData: (payload: any) => void;

  @ServiceBookStore.Getter patchData:IPatchServiceBook


  ServiceBookService:ServiceBookService
  ApartmentService:ApartmentService
  BlockService:BlockService
  dtServiceBook:any
  dtApartmentTypes:any[]
  dtApartments:any[]
  dtBlocks:any[]
  dtRules:any
  isLoading:boolean
  showSelectApartment:boolean
  hasFloor:boolean
  showCreateNewAddress:boolean

  // form
  //floor:string
  //surface:string
  //type:string
  apartment:any
  createNewApartment:boolean
  //name:string
  //address:any
  createNewAddress:boolean
  //block:number
  //apartmentType:any
  //addressReference:string
  blockNameRef:string

  constructor() {
    super();
    this.ServiceBookService = new ServiceBookService()
    this.ApartmentService = new ApartmentService()
    this.BlockService = new BlockService()
    this.dtServiceBook = {}
    this.dtApartmentTypes = []
    this.dtApartments = []
    this.dtBlocks = []
    this.dtRules = {}
    this.isLoading = false
    this.showSelectApartment = false
    this.hasFloor = false
    this.showCreateNewAddress = false

    //this.floor = null
    //this.surface = null
    //this.type = null
    this.apartment = null
    this.createNewApartment = false
    //this.name = null
    //this.address = {}
    this.createNewAddress = false
    //this.block = null
    //this.apartmentType = null
    //this.addressReference = null
    this.blockNameRef = null
  }


  get apartmentType() {
    return this.patchData.fk_apartment_type
  }

  set apartmentType(value:any) {
    if(value)
    {
      this.hasFloor = !value.first_level
    }
    this.storeSetServiceBookPatchData({
      fk_apartment_type: value ? value.id : null
    })

  }

  get name() {
    return this.patchData.apartment_number
  }

  set name(value:any) {
    this.storeSetServiceBookPatchData({
      apartment_number: value ? value : null
    })
  }

  get floor() {
    return this.patchData.floor
  }

  set floor(value:any) {
    this.storeSetServiceBookPatchData({
      floor: value ? value : null
    })
  }

  get surface() {
    return this.patchData.square_meter
  }

  set surface(value:any) {
    this.storeSetServiceBookPatchData({
      square_meter: value ? value : null
    })
  }

  get type() {
    return this.patchData.type
  }

  set type(value:any) {
    this.storeSetServiceBookPatchData({
      type: value ? value : null
    })
  }

  get block() {
    return this.patchData.fk_apartment_block
  }

  set block(value:any) {
    this.storeSetServiceBookPatchData({
      fk_apartment_block: value ? value.id : null
    })
  }



  get addressReference() {
    return this.patchData.address ? this.patchData.address.name : null
  }

  set addressReference(value:any) {
    this.storeSetServiceBookPatchData({
      address:{...this.address, name:value}
    })
  }

  get address() {
    return this.patchData.address ? this.patchData.address : {}
  }

  set address(value:any) {
    this.storeSetServiceBookPatchData({
      address:{...value, name:this.addressReference}
    })
  }


  get fk_apartment() {
    return this.patchData.fk_apartment
  }

  set fk_apartment(value:any) {
    this.storeSetServiceBookPatchData({
      fk_apartment:value
    })
  }


  get lblSetting () {
    return {
      ...require('@/locales/apartment').default,
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/generic-labels').default,
      ...require('@/locales/service-book').default,
      ...require('@/locales/block').default,
    }
  }

  beforeMount()
  {
    this.dtRules = {
      /* nameRules: [ v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceName)})],
      descriptionRules:[v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceDescription)})],
      typeRules:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceType)})],
      stateRules:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceState)})],
      methodRules:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceMethod)})],
      CategorieRules:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceEquipementCategorie)})],
      EquipementRules:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceEquipement)})],
      LastMaintDateRules:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceDate)})],
      managerRules:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceManager)})],
      contractorRules:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceContractor)})],
      IntervalTypeRules:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceIntervalType)})],
      IntervalRules:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceInterval)})],
      alertPreDelay:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceAlertPreDelay)})],
      AttributMaintVal:[
        v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceAttribute)}),
        v=> v<this.currentAttributValue || this.$t(this.lblSetting.requireAttributeValSuperior, {value:`${this.currentAttributValue} ${this.currentAttributUnit}`,type: this.$t(this.lblSetting.labelAttributValue)}),
      ] */
      addressReference: [ v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.serviceBookModal.addressReference)})],
      apartmentName: [ v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.serviceBookModal.apartmentName)})],
      apartmentType: [ v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.serviceBookModal.apartmentType)})],
      block: [ v => !!v || this.$t(this.lblSetting.emptyRequired, {type: "Ce champ"})],
    }

    this.isLoading = true
    this.getData().then(()=>{
      console.log("this.dtServiceBook", this.dtServiceBook)
      console.log("this.dtApartmentTypes", this.dtApartmentTypes)
      console.log("this.dtApartments", this.dtApartments)
      console.log("this.dtBlocks", this.dtBlocks)

      if(this.dtApartments.length) { this.showSelectApartment = true }
    }).finally(()=>{
      this.isLoading = false
    })
  }

  getData():Promise<any>
  {
    return new Promise(async(resolve)=>{
      try {
        this.dtServiceBook = await this.ServiceBookService.getServiceBookById(this.serviceBookId.toString())
        this.dtApartmentTypes = await this.ServiceBookService.getApartmentTypes()
        const apartmentsArray = await this.ApartmentService.getApartments({has_sb:false},true)
        this.dtApartments = apartmentsArray.data
        const blocksArray = await this.BlockService.getBlocks({has_child:this.hasFloor},true)
        this.dtBlocks = blocksArray.data
        resolve(true)
      } catch (error) {
        console.log(error)
      }
    })
  }

  get coApartments() {
    return this.dtApartments.map(x => ({
      value: x.id,
      text: x['location_number'] ? x['location_number'] + ' / ' + x['apartment_number'] : x['apartment_number'],
      ...x
    }));
  }

  get coBlocks() {
    return this.dtBlocks.map(x => {
        const {line1, line2, zip_code, city, country} = x.address
        const array = [line1, line2, zip_code, city, country]
        const filtred = array.filter(n => n)
        return {
          value: x.id,
          text: x.name + " : " +filtred.join(', '),
          ...x
        }
    });
  }

  get coApartmentTypes()
  {
    return this.dtApartmentTypes.map(x => ({
      value: x.id,
      text: x.name,
      ...x
    }));
  }

  async handleGetApartments(key: string, cb:Function) {
    this.isLoading = true
    try {
      const apartmentsArray = await this.ApartmentService.getApartments({
        has_sb:false,
        key
      },true)
      this.dtApartments = apartmentsArray.data
      cb((apartmentsArray.data || []).map(x => ({ value: x.id, text: x.apartment_number, ...x })))
      this.isLoading = false
    } catch (error) {
      console.log(error)
      this.isLoading = false
    }
  }

  async handleGetBlocks(key: string, cb:Function) {
    this.isLoading = true
    try {
      const blocksArray = await this.BlockService.getBlocks({key, has_child:this.hasFloor},true)
      this.dtBlocks = blocksArray.data
      this.isLoading = false
      cb((blocksArray.data || []).map(x => {
        const {line1, line2, zip_code, city, country} = x.address
        const array = [line1, line2, zip_code, city, country]
        const filtred = array.filter(n => n)
        return {
          value: x.id,
          text: x.name + " : " +filtred.join(', '),
          ...x
        }
      }))
    } catch (error) {
      console.log(error)
      this.isLoading = false
    }
  }

  async handleChangeApartment(value) {
    console.log(value)
    if(value)
    {
      // set fk_apartment
      this.fk_apartment = value.id

      // get first_level from apartment type
      const frist_level = this.dtApartmentTypes.filter(x=>x.id===value.fk_apartment_type)
      this.hasFloor = !frist_level[0].frist_level

      // show create new address
      this.showCreateNewAddress = !frist_level[0].frist_level

      this.name = value.apartment_number
      this.floor = value.floor
      this.surface = value.square_meter

      const {line1, line2, zip_code, city, country} = value.block.address
      const array = [line1, line2, zip_code, city, country]
      const filtred = array.filter(n => n)
      this.blockNameRef = value.block.name +" : "+filtred.join(', ')

      // set apartmentType
      this.storeSetServiceBookPatchData({
        fk_apartment_type:value.fk_apartment_type,
        fk_apartment_block:value.block.id
      })

      //this.createNewAddress = false

    } else {
      // reset fk_apartment
      this.fk_apartment = null

      this.name = null
      this.floor = null
      this.surface = null
      this.blockNameRef = null

      // set apartmentType
      this.storeSetServiceBookPatchData({
        fk_apartment_type:null,
        fk_apartment_block:null
      })
    }
  }

  async handleChangeBlock(value) {
    console.log(value)
  }


  async handleChangeApartmentType(value) {

    console.log(value)
    if(!value) {
      this.createNewAddress = false
      return
    }
    this.createNewAddress = value.first_level
    // show create new address
    this.showCreateNewAddress = !value.first_level
  }

}

export default ServiceBookModal;



// WEBPACK FOOTER //
// ./src/containers/service-book/components/service-book-modal/index.ts